export const projects = [
	
	{
		img: 'https://i.postimg.cc/MpKybzxB/Apple-TV.png',
		title: 'Apple TV+ Clone',
		des: 'Apple TV+ is streeming service from the Appple. It features execlusive apple Original Showes and movies from some of the industry talent, with new premiers arriving each month.',
		// demo: 'https://bobbi-brown-project-8xs15wibv-mohak-tripathi.vercel.app/',
		live: 'https://appletvclone.netlify.app/',
		gitHub: 'https://github.com/NishutSuman/Apple-TV-Clone',
		technologies: ['React', 'Redux', 'Express', 'NodeJS', 'MongoDB'],
	},
	{
		img: 'https://i.postimg.cc/k5PTMHLG/image.png',
		title: 'GitHub Repository Activity Tracker',
		des: 'Basically this is a inhouse tool developed by me individually to make the construct week activity tracking of students easier at operational level.',
		// demo: 'https://bobbi-brown-project-8xs15wibv-mohak-tripathi.vercel.app/',
		live: 'https://masai-cw-tool.vercel.app/',
		gitHub: 'https://github.com/NishutSuman/Masai-CW-Tool',
		technologies: ['React', 'Redux', 'Papaparser', 'Tailwind'],
	},

	{
		img: 'https://iili.io/VQV6Na.png',
		title: 'BobbiBrown Clone',
		des: 'It is an online e-commerce beauty cosmetic website which particularly cater the needs to women. .',
		// demo: 'https://bobbi-brown-project-8xs15wibv-mohak-tripathi.vercel.app/',
		live: 'https://grand-sunflower-c54efa.netlify.app/',
		gitHub: 'https://github.com/Tushar504/Fw15-Bobbi-Brown--Project',
		technologies: ['HTML', 'CSS', 'javaScript'],
	},
	
];
